export const visionDep = {
	title: "Dependency Induction Through the Lens of Visual Perception",
	location: "Carnegie Mellon University",
	description: "Enforce visual priors and word concreteness in learning dependency structures built on lexicalized probabilistic context-free grammar (L-PCFG).",
	paper: "https://arxiv.org/abs/2109.09790",
	code: "https://github.com/ruisi-su/concrete_dep",
	authors: "Ruisi Su, Shruti Rijhwani, Hao Zhu, Junxian He, Xinyu Wang, Yonatan Bisk, and Graham Neubig.",
	conf: "The SIGNLL Conference on Computational Natural Language Learning (CoNLL)",
	date: "November 2021.",
}

export const mediaBias = {
	title: "In Plain Sight: Media Bias Through the Lens of Factual Reporting",
	location: "Northeastern University",
	description: "Designed metrics to capture bias in three politically biased media: Huffington Post, Fox News, and New York Times. Our metrics include three bias dimensions: bias type (informational or lexical), aim manner (direct or indirect), and polarity (positive or negative).",
	paper: "https://arxiv.org/abs/1909.02670",
	code: "https://github.com/marshallwhiteorg/emnlp19-media-bias",
	authors: "Lisa Fan, Marshall White, Eva Sharma, Ruisi Su, Prafulla Kumar Choubey, Ruihong Huang, and Lu Wang.",
	conf: "Proceedings of the Conference on Empirical Methods in Natural Language Processing (EMNLP)",
	date: "Short paper, 2019",
}

export const hopeLRL = {
	title: "Pre-Trained Multilingual Sequence-to-Sequence Models: A Hope for Low-Resource Language Translation?",
	location: "Sway AI",
	description: "We conduct a thorough empirical experiment in 10 languages to assess mBART's ability to translate low-resource languages by considering five factors: (1) the amount of fine-tuning data, (2) the noise in the fine-tuning data, (3) the amount of pre-training data in the model, (4) the impact of domain mismatch, and (5) language typology. We found mBART is not a low-resource panacea; we therefore encourage shifting the emphasis from new models to new data.",
	paper: "https://arxiv.org/abs/2203.08850",
	code: "https://github.com/LRLNMT/LRLNMT",
	authors: "En-Shiun Annie Lee, Sarubi Thillainathan, Shravan Nayak, Surangika Ranathunga, David Ifeoluwa Adelani, Ruisi Su, Arya D. McCarthy",
	conf: "Findings of the Association for Computational Linguistics (ACL)",
	date: "Short paper, May 2022",
}

export const bigbio = {
	title: "BigBIO: A Framework for Data-Centric Biomedical Natural Language Processing",
	location: "BigScience",
	description: "BigBIO (BigScience Biomedical) is an open library of biomedical dataloaders built using Huggingface's (🤗) datasets library for data-centric machine learning.",
	paper: "https://arxiv.org/abs/2206.15076",
	code: "https://github.com/bigscience-workshop/biomedical",
	authors: "Jason Alan Fries, Leon Weber, Natasha Seelam, Gabriel Altay, Debajyoti Datta, Samuele Garda, Myungsun Kang, Ruisi Su, Wojciech Kusa, Samuel Cahyawijaya, Fabio Barth, Simon Ott, Matthias Samwald, Stephen Bach, Stella Biderman, Mario Sänger, Bo Wang, Alison Callahan, Daniel León Periñán, Théo Gigant, Patrick Haller, Jenny Chim, Jose David Posada, John Michael Giorgi, Karthik Rangasai Sivaraman, Marc Pàmies, Marianna Nezhurina, Robert Martin, Michael Cullan, Moritz Freidank, Nathan Dahlberg, Shubhanshu Mishra, Shamik Bose, Nicholas Michio Broad, Yanis Labrak, Shlok S Deshmukh, Sid Kiblawi, Ayush Singh, Minh Chien Vu, Trishala Neeraj, Jonas Golde, Albert Villanova del Moral, Benjamin Beilharz",
	conf: "TBD",
	date: "preprint",

}